import mediaQueries from "./media-queries";
import icons from "../imgs/icons";

const columnWrapper = {
  [mediaQueries.desktop]: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "50px"
  }
};

const leftCol = {
  [mediaQueries.desktop]: {
    float: "none",
    flex: "0 0 57%",
    maxWidth: "0 0 57%",
    margin: "0 3% 0 0"
  }
};

const rightCol = {
  margin: "0 auto",
  maxWidth: "535px",
  [mediaQueries.desktop]: {
    margin: "0",
    float: "none",
    flex: "0 0 38%",
    maxWidth: "0 0 38%",
    display: "flex",
    flexDirection: "column"
  }
};

const boxShadow = {
  background: "#ffffff",
  padding: "20px",
  margin: "0 -20px",
  boxShadow: "0 0 13px 0 rgba(0,0,0,0.10)",
  [mediaQueries.tablet]: {
    padding: "28px",
    margin: "0"
  }
};

const title = {
  fontFamily: "JWSansBold",
  fontWeight: "normal",
  margin: "10px 0",
  textAlign: "center",
  textTransform: "uppercase",
  position: "relative",
  zIndex: 1,
  fontSize: "24px",
  lineHeight: "30px",
  letterSpacing: "5px",
  [mediaQueries.tablet]: {
    maxWidth: "none",
    height: "auto",
    margin: "20px 0 50px 0",
    fontSize: "30px",
    lineHeight: "46px",
    letterSpacing: "5px"
  },
  [mediaQueries.desktop]: {
    width: "62%"
  }
};

const instructionalCopy = {
  fontFamily: "JWSansBook",
  textAlign: "center",
  marginTop: "0",
  marginBottom: "15px",
  position: "relative",
  zIndex: 1,
  fontSize: "16px",
  lineHeight: "24px",
  letterSpacing: "0.5px",
  [mediaQueries.tablet]: {
    textAlign: "center",
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.5px"
  }
};

const fixedContainer = {
  [mediaQueries.mobile]: {
    background: "#ffffff",
    position: "fixed",
    width: "100%",
    top: "51px",
    left: "0",
    padding: "20px 30px 0",
    zIndex: 100
  }
};

const fixedContainerGutter = {
  [mediaQueries.tablet]: {
    padding: "0 !important"
  }
};

const previewWrapper = {
  margin: "0 0 20px 0",
  clear: "both",
  border: "2px solid #BB9959",
  [mediaQueries.tablet]: {
    width: "100%",
    margin: "0 auto 20px"
  }
};

const preview = {
  paddingTop: "36.849926%",
  position: "relative",
  overflow: "hidden"
};

const previewImage = {
  width: "100%",
  height: "auto",
  position: "absolute",
  top: "50%",
  minHeight: "100%",
  left: 0,
  transform: "translateY(-50%)"
};

const cutLine = {
  position: "absolute",
  top: 0,
  height: "100%"
};

const cutLineLeft = {
  ...cutLine,
  left: "5.3%"
};

const cutLineRight = {
  ...cutLine,
  right: "5.3%"
};

const selectOption = {
  position: "absolute",
  top: 0,
  left: "50%",
  transform: "translateX(-50.25%)",
  width: "90%",
  marginTop: "5.0%",
  height: "64%"
};

const listItem = {
  position: "relative",
  cursor: "pointer"
};

const editCtas = {
  position: "relative",
  margin: "0",
  overflow: "hidden"
};

const bringToFront = {
  fontFamily: "JWSansBook",
  fontSize: "12px",
  letterSpacing: "0.45px",
  lineHeight: "16px",
  padding: " 0 0 0 21px",
  color: "#000000",
  position: "relative",
  height: "13px",
  background: "none",
  border: "none",
  cursor: "pointer",
  margin: 0,
  display: "inline-block",
  "&:before": {
    content: "''",
    position: "absolute",
    top: 0,
    left: 0,
    background: `url(${icons.bringToFront}) no-repeat`,
    backgroundSize: "100% 100%",
    height: "13px",
    width: "13px"
  },
  [mediaQueries.tablet]: {
    padding: "0 0 0 42px",
    height: "27px",
    "&:before": {
      height: "27px",
      width: "27px"
    }
  }
};

const remove = {
  border: "none",
  background: `url(${icons.bin}) no-repeat`,
  backgroundSize: "100% 100%",
  width: "22px",
  height: "27px",
  cursor: "pointer",
  padding: 0,
  display: "inline-block"
};

const undoButton = {
  border: "none",
  background: `url(${icons.undoIcon}) no-repeat`,
  backgroundSize: "100% 100%",
  margin: "0 20px 0 0",
  width: "22px",
  height: "27px",
  cursor: "pointer",
  padding: 0,
  display: "inline-block"
};

const slider = {
  WebkitAppearance: "none",
  width: "100%",
  background: "transparent",
  height: "30px",
  margin: 0,
  padding: 0,
  "&::-webkit-slider-runnable-track": {
    width: "100%",
    height: "2px",
    backgroundColor: "#BB9959",
    cursor: "pointer"
  },
  "&::-webkit-slider-thumb": {
    WebkitAppearance: "none",
    height: "20px",
    width: "20px",
    borderRadius: "100%",
    background: "#BB9959",
    border: "none",
    cursor: "pointer",
    marginTop: "-9px"
  },
  "&:focus": {
    outline: "none",
    "&::-webkit-slider-runnable-track": {
      background: "#BB9959"
    },
    "&::-ms-fill-lower": {
      background: "#BB9959"
    },
    "&::-ms-fill-upper": {
      background: "#BB9959"
    }
  },
  "&::-moz-range-track": {
    width: "100%",
    height: "2px",
    backgroundColor: "#BB9959",
    cursor: "pointer"
  },
  "&::-moz-range-thumb": {
    height: "20px",
    width: "20px",
    borderRadius: "100%",
    backgroundColor: "#BB9959",
    border: "none",
    cursor: "pointer"
  },
  "&:-moz-focusring": {
    outline: "1px solid white",
    outlineOffset: "-1px"
  },
  "&::-ms-track": {
    width: "100%",
    cursor: "pointer",
    background: "transparent",
    color: "transparent",
    borderColor: "transparent",
    borderWidth: "6px",
    height: "2px",
  },
  "&::-ms-fill-lower": {
    background: "#BB9959",
    borderRadius: "10px",
  },
  "&::-ms-fill-upper": {
    background: "#BB9959",
    borderRadius: "10px",
  },
  "&::-ms-thumb": {
    height: "20px",
    width: "20px",
    borderRadius: "100%",
    background: "#BB9959",
    border: "none",
    cursor: "pointer"
  }
};

export default {
  columnWrapper,
  leftCol,
  rightCol,
  boxShadow,
  title,
  instructionalCopy,
  fixedContainer,
  fixedContainerGutter,
  previewWrapper,
  preview,
  previewImage,
  cutLineLeft,
  cutLineRight,
  selectOption,
  listItem,
  editCtas,
  bringToFront,
  remove,
  undoButton,
  slider
};



// WEBPACK FOOTER //
// ./src/styles/editor.js